<p-toast />
<p-table
  #userTbl
  [value]="usersWithGroupNames()"
  stripedRows
  [paginator]="true"
  [rows]="15"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
  [rowsPerPageOptions]="[5, 10, 15, 20, 50, 100]"
  [globalFilterFields]="['username, email']"
  size="small"
>
  <ng-template #caption>
    <div class="flex">
      @if (hasPermission(permissions.do_crud_users)) {
        <div class="text-start">
          <p-button
            icon="pi pi-user-plus"
            label="Add user"
            (click)="addUser()"
          />
        </div>
      }
      <p-iconfield class="ml-auto">
        <p-inputicon class="pi pi-search" />
        <input
          #searchInput
          type="text"
          pInputText
          placeholder="Search"
          (input)="userTbl.filterGlobal($event.target.value, 'contains')"
        />
        <p-inputicon
          class="pi pi-times text-red-600 hover:cursor-pointer"
          (click)="searchInput.value = ''; userTbl.clear()"
        />
      </p-iconfield>
    </div>
  </ng-template>
  <ng-template #header>
    <tr>
      <th>Username</th>
      <th>Email</th>
      <th class="max-width-fit">Role</th>
      <th class="hidden 2xl:table-cell">Last logged in</th>

      @if (hasPermission(permissions.do_crud_users)) {
        <th class="text-center max-w-[15rem] xl:max-w-[3rem]">Actions</th>
      }
    </tr>
  </ng-template>
  <ng-template #body let-user>
    <tr>
      <td>{{ user.username }}</td>
      <td>{{ user.email }}</td>
      <td class="max-width-fit">{{ user.groupNames }}</td>
      <td class="hidden 2xl:table-cell">{{ user.last_login }}</td>
      @if (hasPermission(permissions.do_crud_users)) {
        <td class="text-center max-w-[15rem] xl:max-w-[3rem]">
          <p-button
            icon="pi pi-pencil"
            class="pr-5"
            [rounded]="true"
            [outlined]="true"
            (click)="editUser(user)"
          />
          <p-button
            icon="pi pi-trash"
            [rounded]="true"
            [outlined]="true"
            severity="danger"
            (click)="confirmDeleteUser($event, user)"
          />
        </td>
      }
    </tr>
  </ng-template>
</p-table>
<p-confirmdialog />

<p-dialog
  [(visible)]="userDialog"
  [style]="{ width: '90rem' }"
  header="User Details"
  [modal]="true"
>
  <ng-template #content>
    <div class="flex flex-col gap-6">
      <div class="md:flex md:flex-row gap-6">
        <div class="w-full">
          <label for="username" class="block font-bold mb-3">Username</label>
          <input
            type="text"
            pInputText
            id="username"
            required
            [(ngModel)]="user.username"
            autofocus
            fluid
          />
        </div>
        <div class="w-full">
          <label for="email" class="block font-bold mb-3">Email</label>
          <input
            type="text"
            pInputText
            id="email"
            required
            fluid
            [(ngModel)]="user.email"
          />
        </div>
      </div>
      @if ("id" in this.user) {
        <div>
          <p-button
            label="Sent change password email"
            [disabled]="getChangePasswordDisabled()"
            (click)="sentChangePasswordMail()"
          />
        </div>
      }
      <div>
        <label for="groups" class="block font-bold mb-3">Linked Roles</label>
        <p-multiselect
          [options]="this.permissionService.permissionGroups()"
          [(ngModel)]="user.group_ids"
          optionLabel="name"
          optionValue="id"
          placeholder="Select role(s)"
          class="w-full"
          appendTo="body"
        />
      </div>
      @if ("id" in this.user) {
        <div>
          <span class="block font-bold mb-4">Notifications</span>
          <div class="grid grid-cols-12 gap-4">
            @for (
              notification of user.notifications;
              track notification.notificationName
            ) {
              <div class="col-span-6 flex items-center gap-4 mb-2">
                <p-toggleswitch
                  [id]="notification.notificationName"
                  [(ngModel)]="notification.value"
                />
                <label [for]="notification.notificationName">{{
                  notificationLabels[notification.notificationName]
                }}</label>
              </div>
            }
          </div>
        </div>
        <div>
          <span class="block font-bold mb-4">Permissions</span>
          <table class="min-w-full text-sm border-collapse">
            <thead class="bg-gray-50">
              <tr class="text-left">
                <th class="px-4 py-3 font-semibold">Permission</th>
                <th class="px-4 py-3 font-semibold">Granted by Role</th>
                <th class="px-4 py-3 font-semibold">Direct Override</th>
                <th class="px-4 py-3 font-semibold">Valid Until</th>
                <th></th>
              </tr>
            </thead>

            <tbody class="divide-y divide-gray-200">
              @for (row of permissionRows; track row.permissionId) {
                <tr class="hover:bg-gray-50">
                  <td class="px-4 py-3">
                    <div class="font-semibold">{{ row.permissionName }}</div>
                    <span class="italic">{{ row.description }}</span>
                  </td>

                  <td class="px-4 py-3">
                    <i
                      [class]="
                        row.grantedByGroup
                          ? 'fa-regular fa-circle-check text-green-500'
                          : 'fa-regular fa-circle-xmark text-red-500'
                      "
                    >
                    </i>
                  </td>

                  <td class="px-4 py-3">
                    {{ row.directOverride ? "" : "—" }}
                    <i
                      [class]="
                        row.directOverride
                          ? 'fa-regular fa-circle-check text-green-500'
                          : ''
                      "
                    >
                    </i>
                  </td>

                  <td class="px-4 py-3">
                    {{ row.validUntil ?? "—" }}
                  </td>
                  <td>
                    <button pButton severity="secondary" disabled="true">
                      <i class="fa-solid fa-user-shield" pButtonIcon></i>
                      <span pButtonLabel class="hidden lg:table-cell"
                        >Add permission</span
                      >
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <div class="md:flex md:flex-row gap-6">
          <div class="w-full">
            <label for="password" class="block font-bold mb-3">Password</label>
            <p-password
              [(ngModel)]="user.password"
              id="password"
              autocomplete="off"
              fluid
              [toggleMask]="true"
              [showClear]="true"
              appendTo="body"
              [minlength]="8"
            />
          </div>
          <div class="w-full">
            <label for="repeatPass" class="block font-bold mb-3"
              >Repeat password</label
            >
            <input
              type="password"
              pInputText
              id="repeatPass"
              required
              fluid
              [(ngModel)]="user.repeatPass"
              [class.ng-invalid]="
                user.password &&
                user.repeatPass &&
                user.password !== user.repeatPass
              "
            />

            @if (getPasswordsMatch()) {
              <small class="text-red-500"> Passwords do not match </small>
            }
          </div>
        </div>
      }
    </div>
  </ng-template>
  <ng-template #footer>
    <p-button label="Cancel" icon="pi pi-times" text (click)="hideDialog()" />
    <p-button
      label="Save"
      icon="pi pi-check"
      [disabled]="getDisableSaveBtn()"
      (click)="saveUser()"
    />
  </ng-template>
</p-dialog>
